<template>
  <section
    v-if="notes.length"
    class="model-notes">
    <h3>Model Notes</h3>

    <div class="notes-container" :style="`overflow-y: ${notes.length > 5 ? 'scroll' : 'auto'};`">
      <p
        v-for="(note, index) of isShowingMore ? notes : notes.slice(0, 5)"
        :key="index"
        class="notes-row">
        <span class="notes-note">{{ note.note }}</span>
        <span
          v-if="note.date"
          class="notes-date">
          {{ note.date | date }}
        </span>
      </p>

      <div class="button-container">
        <v-btn
          v-if="notes.length > 5"
          text
          @click="isShowingMore = !isShowingMore">
          <v-icon>
            {{ isShowingMore ? "mdi-chevron-up" : "mdi-chevron-down" }}
          </v-icon>

          Show {{ isShowingMore ? "Less" : "More" }}
        </v-btn>
      </div>
    </div>

    <span class="last-updated"><b>Last Updated</b>: {{ lastUpdated | date }}</span>
  </section>
</template>

<script>
const props = {
  lastUpdated: {
    default: "2022-07-07",
    required: true,
    type: String,
  },
  notes: {
    default: [],
    required: true,
    type: Array,
  },
};

export default {
  props,
  data: () => ({
    isShowingMore: false,
  }),
};
</script>

<style scoped>
.model-notes {
  margin: 2em 0;
}

.model-notes h3 {
  margin-bottom: 1em;
}

.model-notes p {
  border-radius: .25em;
  box-sizing: border-box;
  margin: 0;
  padding: .5em;
}

.model-notes p:nth-child(odd) {
  background-color: rgba(18, 18, 18, .12);
}

.theme--dark .model-notes p:nth-child(odd) {
  background-color: rgba(255, 255, 255, .07);
}

.notes-container {
  max-height: 800px;
}

.notes-row {
  display: flex;
  gap: 1em;
  justify-content: space-between;
}

.notes-date {
  flex: none;
  font-size: .8rem;
  font-style: italic;
  text-align: right;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 1em;
}

.last-updated {
  display: block;
  font-size: .8rem;
  font-style: italic;
  margin-top: -1em;
  padding-right: .5rem;
  text-align: right;
}
</style>